const dropdownQuery = window.matchMedia('(min-width: 750px)');

function setupSunfadeSearchDropdown() {
  const dialog = document.querySelector('dialog.search-modal__content');
  const template = document.querySelector('#SunfadePopularSearches');
  const headerField = document.querySelector('[data-sunfade-header-search]');
  const headerInput = headerField?.querySelector('[data-sunfade-header-search-input]');

  if (!dialog || !template) return;

  const getNativeTrigger = () => {
    const buttons = [...document.querySelectorAll('#header-component .search-modal__button')];

    return (
      buttons.find((button) => button.closest('search-button')?.classList.contains('mobile:hidden')) || buttons[0]
    );
  };

  const getDesktopAnchor = () => {
    if (headerField && headerField.getBoundingClientRect().width > 0) return headerField;

    return [...document.querySelectorAll('#header-component .search-modal__button')].find((button) => {
      const rect = button.getBoundingClientRect();
      return rect.width > 0 && getComputedStyle(button).display !== 'none';
    });
  };

  const mountPopularSearches = () => {
    const content = dialog.querySelector('.predictive-search-form__content');
    if (!content || content.querySelector('[data-sunfade-popular-searches]')) return;

    content.prepend(template.content.cloneNode(true));
  };

  const setMobileStage = (stage) => {
    if (dropdownQuery.matches) return;

    dialog.dataset.sunfadeMobileStage = stage;
  };

  const prepareMobileDialog = ({ resetStage = false } = {}) => {
    if (dropdownQuery.matches) {
      dialog.classList.remove('sunfade-mobile-search');
      delete dialog.dataset.sunfadeMobileStage;
      return;
    }

    const announcement = document.querySelector('#header-group .announcement-bar');
    const announcementBottom = Math.max(0, announcement?.getBoundingClientRect().bottom || 0);

    ['position', 'top', 'right', 'bottom', 'left', 'width', 'height'].forEach((property) => {
      dialog.style.removeProperty(property);
    });
    dialog.style.setProperty('--sunfade-mobile-search-top', `${announcementBottom}px`);
    dialog.classList.remove('sunfade-search-dropdown', 'dialog-closing');
    dialog.classList.add('sunfade-mobile-search');

    if (resetStage || !dialog.dataset.sunfadeMobileStage) setMobileStage('input');

    const input = dialog.querySelector('.search-input');
    if (input) input.placeholder = 'What can we help you find?';

    mountPopularSearches();
  };

  const prepareDialog = () => {
    if (!dropdownQuery.matches) {
      prepareMobileDialog();
      return;
    }

    dialog.classList.remove('sunfade-mobile-search');
    delete dialog.dataset.sunfadeMobileStage;

    const trigger = getDesktopAnchor();
    if (!trigger) return;

    const rect = trigger.getBoundingClientRect();
    const preferredWidth = Math.min(580, window.innerWidth - rect.left - 24);
    const dropdownTop = rect.bottom + 6;
    const dropdownWidth = Math.max(rect.width, preferredWidth);

    dialog.style.setProperty('--sunfade-search-left', `${rect.left}px`);
    dialog.style.setProperty('--sunfade-search-top', `${dropdownTop}px`);
    dialog.style.setProperty('--sunfade-search-width', `${dropdownWidth}px`);
    dialog.style.setProperty('--sunfade-search-trigger-width', `${rect.width}px`);
    dialog.style.setProperty('--sunfade-search-trigger-height', `${rect.height}px`);
    dialog.style.setProperty('position', 'fixed', 'important');
    dialog.style.setProperty('top', `${dropdownTop}px`, 'important');
    dialog.style.setProperty('right', 'auto', 'important');
    dialog.style.setProperty('bottom', 'auto', 'important');
    dialog.style.setProperty('left', `${rect.left}px`, 'important');
    dialog.style.setProperty('width', `${dropdownWidth}px`, 'important');
    dialog.style.removeProperty('height');
    dialog.classList.add('sunfade-search-dropdown');

    const input = dialog.querySelector('.search-input');
    if (input) input.placeholder = 'What can we help you find?';

    mountPopularSearches();
  };

  const syncHeaderQuery = () => {
    if (!headerInput) return;

    const input = dialog.querySelector('.search-input');
    if (!input || input.value === headerInput.value) return;

    input.value = headerInput.value;
    // Horizon's predictive-search component ignores a plain synthetic Event:
    // its search handler explicitly requires InputEvent.inputType. Mirror a
    // genuine text edit so the native debounced request runs for this value.
    const inputEvent =
      typeof InputEvent === 'function'
        ? new InputEvent('input', {
            bubbles: true,
            composed: true,
            inputType: 'insertText',
            data: headerInput.value,
          })
        : new Event('input', { bubbles: true });

    input.dispatchEvent(inputEvent);
  };

  const openFromHeaderInput = () => {
    if (!dropdownQuery.matches || dialog.open) return;

    prepareDialog();
    dialog.show();
    mountPopularSearches();
    syncHeaderQuery();
    requestAnimationFrame(() => {
      prepareDialog();
      headerInput?.focus({ preventScroll: true });
    });
  };

  const closeDesktopDropdown = () => {
    if (!dropdownQuery.matches || !dialog.open || dialog.classList.contains('dialog-closing')) return;

    dialog.classList.add('dialog-closing');
    window.setTimeout(() => {
      if (dialog.open) dialog.close();
      dialog.classList.remove('dialog-closing');
    }, 90);
  };

  if (headerInput) {
    headerInput.addEventListener('focus', openFromHeaderInput);
    headerInput.addEventListener('click', openFromHeaderInput);
    headerInput.addEventListener('input', () => {
      openFromHeaderInput();
      syncHeaderQuery();
    });
    headerInput.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDesktopDropdown();
        headerInput.blur();
      }

      if (event.key === 'Enter' && headerInput.value.trim()) {
        event.preventDefault();
        window.location.assign(`/search?q=${encodeURIComponent(headerInput.value.trim())}`);
      }
    });

    dialog.addEventListener('input', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.matches('.search-input')) {
        headerInput.value = event.target.value;
      }
    });
  }

  dialog.addEventListener('pointerdown', (event) => {
    if (dropdownQuery.matches || !dialog.open) return;

    if (event.target instanceof Element && event.target.closest('.search-input')) {
      setMobileStage('results');
    }
  });

  dialog.addEventListener('input', (event) => {
    if (dropdownQuery.matches || !dialog.open) return;

    if (event.target instanceof HTMLInputElement && event.target.matches('.search-input')) {
      setMobileStage('results');
    }
  });

  document.querySelectorAll('#header-component .search-modal__button').forEach((button) => {
    button.addEventListener('pointerdown', prepareDialog);
    button.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') prepareDialog();
    });
    button.addEventListener('click', () => requestAnimationFrame(prepareDialog));
  });

  let wasOpen = dialog.open;

  const observer = new MutationObserver(() => {
    if (dialog.open) {
      if (dropdownQuery.matches) {
        prepareDialog();
      } else {
        prepareMobileDialog({ resetStage: !wasOpen });
      }
      mountPopularSearches();
      headerInput?.setAttribute('aria-expanded', 'true');

      if (!wasOpen) {
        syncHeaderQuery();
      }
    } else {
      headerInput?.setAttribute('aria-expanded', 'false');
      dialog.classList.remove('sunfade-mobile-search');
      delete dialog.dataset.sunfadeMobileStage;
    }

    wasOpen = dialog.open;
  });

  observer.observe(dialog, {
    attributes: true,
    attributeFilter: ['open'],
    childList: true,
    subtree: true,
  });

  document.addEventListener('pointerdown', (event) => {
    if (!dropdownQuery.matches || !dialog.open) return;
    if (dialog.contains(event.target) || headerField?.contains(event.target)) return;

    closeDesktopDropdown();
  });

  window.addEventListener('resize', () => {
    if (!dialog.open) return;

    if (dropdownQuery.matches) {
      prepareDialog();
    } else {
      prepareMobileDialog();
    }
  }, { passive: true });

  window.addEventListener('scroll', () => {
    if (dialog.open && dropdownQuery.matches) prepareDialog();
  }, { passive: true });

  if (headerField && 'ResizeObserver' in window) {
    new ResizeObserver(() => {
      if (dialog.open && dropdownQuery.matches) prepareDialog();
    }).observe(headerField);
  }

  dropdownQuery.addEventListener('change', () => {
    if (dialog.open) dialog.close();
    dialog.classList.remove('dialog-closing', 'sunfade-search-dropdown', 'sunfade-mobile-search');
    delete dialog.dataset.sunfadeMobileStage;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupSunfadeSearchDropdown, { once: true });
} else {
  setupSunfadeSearchDropdown();
}
